import { RelatedRecipesController } from "./related_recipes_controller";
import $ from "jquery";
import { RelatedCombinationRecipesView } from "../view/related_combination_recipes_view";

class RelatedCombinationRecipesController extends RelatedRecipesController {
  constructor() {
    super();
    this.view = new RelatedCombinationRecipesView(
      this.relatedRecipesBoxElement(),
      this.keyword(),
    );
  }

  render(): JQuery.Promise<any> {
    this.query = new RelatedCombinationRecipesQuery(
      this.ajaxUrl(),
      this.itemId(),
      this.pairingItemIds(),
    );

    return this.query.execute().then(
      (recipes: any) => {
        this.view.renderRelatedRecipes(recipes);
      },
      (_res: any) => {
        this.view.renderErrorMessage("関連レシピの取得に失敗しました");
      },
    );
  }

  renderKeywordNotFound(): void {
    this.view.renderKeywordNotFoundMessage();
  }

  private pairingItemIdsSelector(): string {
    return "pairingItemIds";
  }

  private pairingItemIds(): number[] {
    return this.relatedRecipesBoxElement().data(this.pairingItemIdsSelector());
  }

  setPairingItemIds(pairingItemIds: number[]): void {
    this.relatedRecipesBoxElement().data(
      this.pairingItemIdsSelector(),
      pairingItemIds,
    );
  }

  private keyword(): string {
    return this.relatedRecipesBoxElement().data("keyword");
  }
}

class RelatedCombinationRecipesQuery {
  private url: string;
  private itemId: string;
  private pairingItemIds: number[];

  constructor(url: string, itemId: string, pairingItemIds: number[]) {
    this.url = url;
    this.itemId = itemId;
    this.pairingItemIds = pairingItemIds;
  }

  execute(): JQuery.jqXHR {
    return $.ajax({
      url: this.url,
      data: this.makeParams(),
      dataType: "json",
    });
  }

  private makeParams(): any {
    return {
      item_id: this.itemId,
      pairing_item_id: this.pairingItemIds,
    };
  }
}

export { RelatedCombinationRecipesController, RelatedCombinationRecipesQuery };
